import { useState, useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import Card from '../../components/base/Card';
import Button from '../../components/base/Button';

export default function Sobre() {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [showContactModal, setShowContactModal] = useState(false);
  const [contactType, setContactType] = useState('');

  const heroImages = [
    'https://static.readdy.ai/image/3b71a02bb86d4e011a6e698798aa6f47/f01bd1f41eb64e76d4a1826e5d77266b.png',
    'https://static.readdy.ai/image/3b71a02bb86d4e011a6e698798aa6f47/1d2095162674ffcabbb67e97472b0d85.png',
    'https://static.readdy.ai/image/3b71a02bb86d4e011a6e698798aa6f47/7e83693915644a7a616d1640140ba862.jpeg',
    'https://readdy.ai/api/search-image?query=professional%20food%20service%20kitchen%2C%20commercial%20kitchen%20equipment%2C%20restaurant%20kitchen%20setup%2C%20food%20preparation%20area%2C%20professional%20culinary%20environment&width=1920&height=600&seq=aboutHero4&orientation=landscape',
    'https://static.readdy.ai/image/3b71a02bb86d4e011a6e698798aa6f47/3002085b90eb431784c91b45fba455d4.png',
    'https://static.readdy.ai/image/3b71a02bb86d4e011a6e698798aa6f47/617e947477817855dc686714a3425cd9.png'
  ];

  // Auto-rotate images
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) =>
        prevIndex === heroImages.length - 1 ? 0 : prevIndex + 1
      );
    }, 4000); // Change image every 4 seconds

    return () => clearInterval(interval);
  }, [heroImages.length]);

  const timeline = [
    {
      year: '2003',
      title: 'Fundação da Tecnutri',
      description: 'Início das atividades com foco em produtos para alimentação empresarial'
    },
    {
      year: '2008',
      title: 'Expansão da Linha',
      description: 'Lançamento da linha de sobremesas e bebidas especializadas'
    },
    {
      year: '2012',
      title: 'Certificações IFS',
      description: 'Conquista das certificações de qualidade e segurança alimentar'
    },
    {
      year: '2016',
      title: 'Linha Industrial',
      description: 'Desenvolvimento de produtos para produção em larga escala'
    },
    {
      year: '2020',
      title: 'Inovação Digital',
      description: 'Modernização dos processos e atendimento digital'
    },
    {
      year: '2024',
      title: 'Sustentabilidade',
      description: 'Implementação de práticas sustentáveis em toda a cadeia produtiva'
    }
  ];

  const team = [
    {
      name: 'Carlos Silva',
      position: 'CEO & Fundador',
      image: 'https://readdy.ai/api/search-image?query=professional%20business%20executive%20CEO%20portrait%2C%20middle%20aged%20man%20in%20suit%2C%20confident%20leadership%20pose%2C%20corporate%20headshot%2C%20business%20professional%20photography&width=300&height=300&seq=team1&orientation=squarish',
      description: 'Mais de 25 anos de experiência no setor alimentício'
    },
    {
      name: 'Ana Santos',
      position: 'Diretora de Qualidade',
      image: 'https://readdy.ai/api/search-image?query=professional%20female%20executive%20portrait%2C%20quality%20director%2C%20confident%20businesswoman%2C%20corporate%20headshot%2C%20professional%20business%20photography&width=300&height=300&seq=team2&orientation=squarish',
      description: 'Especialista em segurança alimentar e controle de qualidade'
    },
    {
      name: 'Roberto Lima',
      position: 'Diretor Comercial',
      image: 'https://static.readdy.ai/image/3b71a02bb86d4e011a6e698798aa6f47/34a37bf1898591f7be51999cc337ac6c.jfif',
      description: 'Responsável pela expansão nacional da marca'
    },
    {
      name: 'Marina Costa',
      position: 'Chef de Desenvolvimento',
      image: 'https://readdy.ai/api/search-image?query=professional%20female%20chef%20portrait%2C%20culinary%20development%20specialist%2C%20chef%20uniform%2C%20food%20industry%20professional%2C%20culinary%20expert%20photography&width=300&height=300&seq=team4&orientation=squarish',
      description: 'Criação e desenvolvimento de novas receitas e produtos'
    }
  ];

  const values = [
    {
      icon: 'ri-award-line',
      title: 'Qualidade',
      description: 'Compromisso com a excelência em todos os nossos produtos e processos'
    },
    {
      icon: 'ri-leaf-line',
      title: 'Sustentabilidade',
      description: 'Práticas responsáveis que respeitam o meio ambiente'
    },
    {
      icon: 'ri-lightbulb-line',
      title: 'Inovação',
      description: 'Desenvolvimento contínuo de soluções para o mercado food service'
    },
    {
      icon: 'ri-team-line',
      title: 'Parceria',
      description: 'Relacionamento próximo e duradouro com nossos clientes'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Confiança',
      description: 'Transparência e segurança em todas as nossas relações comerciais'
    },
    {
      icon: 'ri-rocket-line',
      title: 'Crescimento',
      description: 'Apoio ao desenvolvimento e sucesso dos nossos parceiros'
    }
  ];

  const stats = [
    { number: '+20', label: 'Anos de Experiência' },
    { number: '+500', label: 'Clientes Ativos' },
    { number: '+100', label: 'Produtos Desenvolvidos' },
    { number: '+ 20', label: 'Estados Atendidos' }
  ];

  const handleContactClick = (type: string) => {
    setContactType(type);
    setShowContactModal(true);
  };

  const handleModalAction = () => {
    setShowContactModal(false);
    
    if (contactType === 'falar') {
      document.querySelector('#vapi-widget-floating-button')?.click();
    } else if (contactType === 'parceiro') {
      window.location.href = 'mailto:parceria@tecnutri.com.br?subject=Interesse em Parceria Comercial';
    }
  };

  const handleTeamMemberClick = (member: any) => {
    const message = `Gostaria de saber mais sobre ${member.name} - ${member.position}. ${member.description}`;
    document.querySelector('#vapi-widget-floating-button')?.click();
  };

  const handleTimelineClick = (item: any) => {
    const message = `Gostaria de saber mais detalhes sobre: ${item.title} (${item.year}) - ${item.description}`;
    document.querySelector('#vapi-widget-floating-button')?.click();
  };

  return (
    <div className="min-h-screen">
      <Header />
      
      {/* Hero Section with Rotating Images */}
      <section className="relative py-32 overflow-hidden">
        {/* Image Carousel */}
        <div className="absolute inset-0">
          {heroImages.map((image, index) => (
            <div
              key={index}
              className={`absolute inset-0 transition-opacity duration-1000 ${
                index === currentImageIndex ? 'opacity-100' : 'opacity-0'
              }`}
            >
              <div
                className="w-full h-full bg-cover bg-center bg-no-repeat"
                style={{
                  backgroundImage: `url('${image}')`
                }}
              />
            </div>
          ))}
        </div>
        
        {/* Overlay */}
        <div className="absolute inset-0 bg-gradient-to-b from-black/15 via-black/10 to-black/15"></div>
        
        {/* Content */}
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center text-white">
          <h1 className="text-5xl md:text-6xl font-bold mb-6">
            Sobre a Tecnutri
          </h1>
          <p className="text-xl md:text-2xl text-white/90 max-w-3xl mx-auto">
            Há mais de 20 anos oferecendo produtos de qualidade em alimentação. 
Sua cozinha profissional merece o melhor.
          </p>
        </div>

        {/* Image Indicators */}
        <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-20">
          <div className="flex space-x-2">
            {heroImages.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentImageIndex(index)}
                className={`w-3 h-3 rounded-full transition-all duration-300 ${
                  index === currentImageIndex 
                    ? 'bg-white scale-125' 
                    : 'bg-white/50 hover:bg-white/75'
                }`}
              />
            ))}
          </div>
        </div>
      </section>

      <main className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          
          {/* Company Story */}
          <section className="mb-20">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
              <div>
                <span className="text-red-600 font-semibold text-lg">Nossa História</span>
                <h2 className="text-4xl font-bold text-gray-900 mt-2 mb-6">
                  Tradição e Inovação
                </h2>
                <div className="space-y-4 text-lg text-gray-600">
                  <p>
                    A Tecnutri nasceu em 2003 com o objetivo de revolucionar o mercado de food service no Brasil. 
                    Fundada por profissionais experientes do setor alimentício, nossa empresa sempre teve como 
                    missão oferecer produtos de alta qualidade para cozinhas profissionais.
                  </p>
                  <p>
                    Ao longo dos anos, desenvolvemos uma linha completa de produtos que atende desde pequenos 
                    restaurantes até grandes redes hospitalares e empresariais. Nossa dedicação à qualidade e 
                    inovação nos tornou referência no setor.
                  </p>
                  <p>
                    Hoje, com mais de 20 anos de experiência, continuamos investindo em pesquisa e desenvolvimento 
                    para oferecer as melhores soluções para nossos clientes em todo o país.
                  </p>
                </div>
              </div>
              
              <div className="aspect-[4/3] rounded-2xl overflow-hidden">
                <img
                  src="https://static.readdy.ai/image/3b71a02bb86d4e011a6e698798aa6f47/62b461e2c6c0966de51b05c1ffe8da16.png"
                  alt="Instalações Tecnutri"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </section>

          {/* Stats */}
          <section className="mb-20">
            <div className="bg-red-600 rounded-2xl p-12 text-white">
              <div className="text-center mb-12">
                <h2 className="text-4xl font-bold mb-4">Números que Falam por Si</h2>
                <p className="text-xl text-red-100">Resultados conquistados com dedicação e qualidade</p>
              </div>
              
              <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
                {stats.map((stat, index) => (
                  <div key={index} className="text-center">
                    <div className="text-4xl md:text-5xl font-bold text-yellow-300 mb-2">
                      {stat.number}
                    </div>
                    <div className="text-red-100 font-medium">
                      {stat.label}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </section>

          {/* Timeline */}
          <section className="mb-20">
            <div className="text-center mb-12">
              <span className="text-red-600 font-semibold text-lg">Evolução</span>
              <h2 className="text-4xl font-bold text-gray-900 mt-2 mb-4">
                Nossa Trajetória
              </h2>
              <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                Marcos importantes que definiram nossa jornada de crescimento e inovação
              </p>
            </div>
            
            <div className="relative">
              <div className="absolute left-1/2 transform -translate-x-1/2 w-1 h-full bg-red-200"></div>
              
              <div className="space-y-12">
                {timeline.map((item, index) => (
                  <div key={index} className={`flex items-center ${index % 2 === 0 ? 'flex-row' : 'flex-row-reverse'}`}>
                    <div className={`w-1/2 ${index % 2 === 0 ? 'pr-8 text-right' : 'pl-8 text-left'}`}>
                      <Card 
                        className="inline-block cursor-pointer hover:shadow-lg transition-shadow"
                        onClick={() => handleTimelineClick(item)}
                      >
                        <div className="text-2xl font-bold text-red-600 mb-2">{item.year}</div>
                        <h3 className="text-xl font-semibold text-gray-900 mb-2">{item.title}</h3>
                        <p className="text-gray-600">{item.description}</p>
                      </Card>
                    </div>
                    
                    <div className="relative z-10 w-4 h-4 bg-red-600 rounded-full border-4 border-white shadow-lg"></div>
                    
                    <div className="w-1/2"></div>
                  </div>
                ))}
              </div>
            </div>
          </section>

          {/* Values */}
          <section className="mb-20">
            <div className="text-center mb-12">
              <span className="text-red-600 font-semibold text-lg">Nossos Valores</span>
              <h2 className="text-4xl font-bold text-gray-900 mt-2 mb-4">
                O que nos Move
              </h2>
              <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                Princípios que guiam nossas ações e decisões diariamente
              </p>
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
              {values.map((value, index) => (
                <Card key={index} className="text-center">
                  <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
                    <i className={`${value.icon} text-2xl text-red-600`}></i>
                  </div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-3">
                    {value.title}
                  </h3>
                  <p className="text-gray-600">
                    {value.description}
                  </p>
                </Card>
              ))}
            </div>
          </section>

          {/* Certifications */}
          <section className="mb-20">
            <div className="text-center mb-12">
              <span className="text-red-600 font-semibold text-lg">Certificações</span>
              <h2 className="text-4xl font-bold text-gray-900 mt-2 mb-4">
                Qualidade Garantida
              </h2>
              <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                Nossos produtos são desenvolvidos e produzidos de acordo com as mais rigorosas normas de segurança e qualidade
              </p>
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
              <Card className="text-center">
                <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-award-line text-2xl text-red-600"></i>
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-3">
                  IFS
                </h3>
                <p className="text-gray-600">
                  Certificado de Qualidade e Segurança Alimentar
                </p>
              </Card>
              
              <Card className="text-center">
                <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-leaf-line text-2xl text-red-600"></i>
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-3">
                  Sustentabilidade
                </h3>
                <p className="text-gray-600">
                  Práticas ambientais responsáveis e sustentáveis
                </p>
              </Card>
              
              <Card className="text-center">
                <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-lightbulb-line text-2xl text-red-600"></i>
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-3">
                  Inovação
                </h3>
                <p className="text-gray-600">
                  Desenvolvimento constante de novas soluções e tecnologias
                </p>
              </Card>
              
              <Card className="text-center">
                <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-team-line text-2xl text-red-600"></i>
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-3">
                  Parceria
                </h3>
                <p className="text-gray-600">
                  Relacionamento próximo e duradouro com nossos clientes
                </p>
              </Card>
            </div>
          </section>

          {/* Mission, Vision, Values */}
          <section className="mb-20">
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
              <Card className="text-center bg-gradient-to-br from-red-50 to-red-100">
                <div className="w-16 h-16 bg-red-600 rounded-full flex items-center justify-center mx-auto mb-6">
                  <i className="ri-target-line text-2xl text-white"></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-4">Missão</h3>
                <p className="text-gray-700">
                  Fornecer produtos de alta qualidade para o mercado food service, 
                  contribuindo para o sucesso dos nossos clientes através de soluções inovadoras.
                </p>
              </Card>
              
              <Card className="text-center bg-gradient-to-br from-yellow-50 to-yellow-100">
                <div className="w-16 h-16 bg-yellow-600 rounded-full flex items-center justify-center mx-auto mb-6">
                  <i className="ri-eye-line text-2xl text-white"></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-4">Visão</h3>
                <p className="text-gray-700">
                  Ser a empresa líder em soluções alimentares para o mercado food service, 
                  reconhecida pela qualidade, inovação e excelência no atendimento.
                </p>
              </Card>
              
              <Card className="text-center bg-gradient-to-br from-green-50 to-green-100">
                <div className="w-16 h-16 bg-green-600 rounded-full flex items-center justify-center mx-auto mb-6">
                  <i className="ri-heart-line text-2xl text-white"></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-4">Compromisso</h3>
                <p className="text-gray-700">
                  Manter os mais altos padrões de qualidade e segurança alimentar, 
                  sempre priorizando a satisfação e o sucesso dos nossos parceiros.
                </p>
              </Card>
            </div>
          </section>

          {/* Call to Action */}
          <div className="text-center bg-gray-50 rounded-2xl p-12">
            <h3 className="text-3xl font-bold text-gray-900 mb-4">
              Quer Fazer Parte da Nossa História?
            </h3>
            <p className="text-xl text-gray-600 mb-8 max-w-2xl mx-auto">
              Entre em contato conosco e descubra como adquirir nossos produtos para facilitar seu negócio a crescer. 
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Button size="lg" onClick={() => handleContactClick('falar')}>
                <i className="ri-phone-line mr-2"></i>
                Falar Conosco
              </Button>
              <Button variant="outline" size="lg" onClick={() => handleContactClick('parceiro')}>
                <i className="ri-building-line mr-2"></i>
                Seja um Parceiro
              </Button>
            </div>
          </div>
        </div>
      </main>

      {/* Contact Modal */}
      {showContactModal && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-2xl max-w-md w-full p-8 text-center">
            <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-6">
              <i className={`${contactType === 'falar' ? 'ri-phone-line' : 'ri-building-line'} text-2xl text-red-600`}></i>
            </div>
            
            <h3 className="text-2xl font-bold text-gray-900 mb-4">
              {contactType === 'falar' ? 'Falar Conosco' : 'Parceria Comercial'}
            </h3>
            
            <p className="text-gray-600 mb-8">
              {contactType === 'falar' 
                ? 'Nossa equipe está pronta para atender você. Clique no botão abaixo para iniciar uma conversa.'
                : 'Interessado em ser nosso parceiro? Vamos abrir seu e-mail para que você possa nos enviar sua proposta.'
              }
            </p>
            
            <div className="flex gap-4">
              <Button 
                variant="outline" 
                className="flex-1"
                onClick={() => setShowContactModal(false)}
              >
                Cancelar
              </Button>
              <Button 
                className="flex-1"
                onClick={handleModalAction}
              >
                {contactType === 'falar' ? 'Iniciar Conversa' : 'Abrir E-mail'}
              </Button>
            </div>
          </div>
        </div>
      )}

      <Footer />
    </div>
  );
}
